<template>
  <div class="theme-edit">
    <button class="normal-btn" @click="isShowModal = true">保存</button>
    <ul class="edit-list">
      <li @click="$emit('showDesignDetail','page')">
        <span class="edit-color slash"/>
        見出し
      </li>
      <li v-for="section in sections" :key="section.id" @click="$emit('showDesignDetail', section.name)">
        <span class="edit-color" :style="{ background: sectionBackground(section) }"/>
        {{ section.displayName }}
      </li>
      <li @click="$emit('showDesignDetail','mobile')">
        <span class="edit-color slash"/>
        モバイル
      </li>
      <li class="line" @click="$emit('showDesignDetail','original')">
        <span class="edit-color slash"/>
        オリジナルスタイル
      </li>
    </ul>
    <portal v-if="isShowModal" to="modal1">
      <theme-save-popup
        :themes="themes"
        @close="isShowModal = false"
        @saved="saved"
      />
    </portal>
  </div>
</template>

<script>
import ThemeSavePopup from '@/components/Content/Palette/ContentDesign/ThemeSavePopup'

export default {
  name: 'content-design-edit',
  components: {
    ThemeSavePopup
  },
  data () {
    return {
      isShowModal: false,
    }
  },
  computed: {
    sections: {
      cache: false,
      get () {
        return this.$store.getters.getSectionAll
      }
    },
    themes () {
      return this.$store.getters.getThemes
    },
    themeNum () {
      return this.$store.getters.getThemeNum
    },
    sectionBackground () {
      return function (section) {
        return this.$store.getters.findSectionStyle(section.name, 'background')
      }
    },
  },
  methods: {
    saved () {
      this.$emit('updateTheme')
      this.$emit('openTab', 'Themes')
      this.isShowModal = false
    },
  },
}
</script>
<style lang="scss" scoped>
.theme-edit {
  .normal-btn {
    box-sizing: border-box;
    border: 1px solid #484848;
    color: #fff;
    background: #484848;
    font-size: 14px;
    margin: 0 0 10px 10px;
    &:hover {
      opacity: 0.8;
    }
  }
  .edit-list {
    font-size: 16px;
    li {
      display: flex;
      padding: 10px;
      transition: all 0.3s ease 0s;
      &:hover {
        border-radius: 2px;
        background: #e4e4e4;
        cursor: pointer;
      }
      .edit-color {
        width: 24px;
        height: 24px;
        display: inline-block;
        border: #dbdbdb 0.5px solid;
        border-radius: 2px;
        margin-right: 16px;
        &.slash {
          // 斜線
          background: linear-gradient(135deg, white, white 45%, black 45%, black 55%, white 55%, white);
        }
      }
    }
    .line {
      border-top: 0.5px solid #dbdbdb;
    }
  }
}
</style>
